import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { popoverAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: popoverAnatomy.keys(),
  base: {
    content: {
      overflow: "hidden",
    },
    // The content stops at the space available (Chakra's maxHeight) and
    // clips: the body scrolls instead, so long content stays reachable on
    // small screens.
    body: {
      minHeight: "0",
      overflowY: "auto",
    },
  },
});
